import st from "lib/utils/index";
import { ProductsRepository, WidgetsRepository } from "lib/repositories/index";
import { APP_ENV } from "config/globals";
export const INITIALIZE_VIEW = "settings/WidgetsSettingsView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "settings/WidgetsSettingsView/DESTROY_VIEW";
export const FETCH_PRODUCTS_SUCCESS = "settings/WidgetsSettingsView/FETCH_PRODUCTS_SUCCESS";
export const FETCH_WIDGETS_SUCCESS = "settings/WidgetsSettingsView/FETCH_WIDGETS_SUCCESS";
export const CREATE_WIDGET = "settings/WidgetsSettingsView/CREATE_WIDGET";

export const stateSelector = (state) => state.settings.WidgetsSettingsView;
const CURRENT_COMPANY_ID_CACHE_KEY = `socialtravel-partnerapp-${APP_ENV}/auth/company.id`;

const initialState = {
  products: [],
  widgets: [],
};

const reducers = {
  [INITIALIZE_VIEW]: () => initialState,

  [FETCH_PRODUCTS_SUCCESS]: (state, { products }) => ({
    ...state,
    products,
  }),
  [FETCH_WIDGETS_SUCCESS]: (state, { widgets }) => ({
    ...state,
    widgets,
  }),
};

const epics = [
  (actions$) =>
    actions$.ofType(INITIALIZE_VIEW).flatMap(() => {
      return ProductsRepository.search({
        status: "published",
      }).map((products) => ({
        type: FETCH_PRODUCTS_SUCCESS,
        products: products,
      }));
    }),

  (actions$) =>
    actions$.ofType(INITIALIZE_VIEW).flatMap(() => {
      const currentCompanyId = window.localStorage.getItem(CURRENT_COMPANY_ID_CACHE_KEY);
      return WidgetsRepository.fetchAll(currentCompanyId).map((widgets) => ({
        type: FETCH_WIDGETS_SUCCESS,
        widgets: widgets.data,
      }));
    }),

  (actions$) =>
    actions$.ofType(CREATE_WIDGET).flatMap(() => {
      const currentCompanyId = window.localStorage.getItem(CURRENT_COMPANY_ID_CACHE_KEY);
      return WidgetsRepository.fetchAll(currentCompanyId).map((widgets) => ({
        type: FETCH_WIDGETS_SUCCESS,
        widgets,
      }));
    }),
];

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}
export function fetchWidgets() {}

export function createWidget(widget) {
  const currentCompanyId = window.localStorage.getItem(CURRENT_COMPANY_ID_CACHE_KEY);
  return WidgetsRepository.createWidget(currentCompanyId, widget);
}
export function updateWidget(widget) {
  const currentCompanyId = window.localStorage.getItem(CURRENT_COMPANY_ID_CACHE_KEY);
  const widgetId = widget.widget.id;
  return WidgetsRepository.updateWidget(currentCompanyId, widget, widgetId);
}
export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/WidgetsSettingsView/index.js